module.exports = __webpack_public_path__ + "static/media/flags_MEX.7ff9226f.svg";